import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.COMMON_SET_CONSUMPTION_TAX_LIST]: (state, payload) => {
    const base = payload.consumptionTaxList
    const consumptionTaxListTmp = base.map((ele) => {
      return {
        consumptionTaxId: ele.consumptionTaxId,
        taxRate: ele.taxRate
      }
    })

    state.taxRateList = consumptionTaxListTmp
  },
  [mutationsTypes.COMMON_SET_CURRENCY_LIST]: (state, payload) => {
    state.currencyList = payload.currencyList

    // const jp = '日本円'
    const jpCode = payload.currencyList.find((ele) => ele.currencyId === 1)
    state.currencyJp = jpCode
      ? { label: jpCode.name, value: jpCode.currencyId }
      : { label: '-', value: null }
  },
  [mutationsTypes.COMMON_SET_COUNTRY_LIST]: (state, payload) => {
    const base = payload.countryList
    const countryListTmp = base.map((ele) => {
      const regionListTmp = ele.regionList.map((subEle) => {
        return {
          regionId: subEle.regionId,
          code: subEle.code,
          countryId: subEle.countryId,
          name: subEle.name
        }
      })

      return {
        countryId: ele.countryId,
        name: ele.name,
        showableRegionPulldown: ele.showableRegionPulldown,
        code: ele.code,
        regionList: regionListTmp
      }
    })

    state.countryList = countryListTmp

    const jp = '日本'
    const jpCode = countryListTmp.find((ele) => ele.name === jp)
    state.countryJp = jpCode
      ? { label: jpCode.name, value: jpCode.countryId }
      : { label: '', value: null }
  },
  [mutationsTypes.COMMON_SET_COUNTRY_CALLING_CODE_LIST]: (state, payload) => {
    const base = payload.countryCallingCodeList
    const countryCallingCodeListTmp = base.map((ele) => {
      return {
        countryId: ele.countryId,
        code: ele.code,
        countryName: ele.countryName
      }
    })

    state.countryCallingCodeList = countryCallingCodeListTmp

    const jp = '81'
    const jpCode = countryCallingCodeListTmp.find(
      (ele) => Number(ele.code) === Number(jp)
    )
    state.countryCallingCodeJp = jpCode
      ? { label: '+' + jpCode.code, value: jpCode.countryId }
      : { label: '', value: null }
  },
  [mutationsTypes.COMMON_SET_PRODUCT_CATEGORY_LIST]: (state, payload) => {
    state.productCategoryList = payload.productCategoryList
  },
  [mutationsTypes.COMMON_SET_CUSTOMER_CATEGORY_LIST]: (state, payload) => {
    state.customerCategoryList = payload.customerCategoryList

    const sortNumberList = payload.customerCategoryList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.customerCategoryMaxSortNumber = Math.max(...sortNumberList)
    }
  },
  [mutationsTypes.COMMON_SET_BRAND_LIST]: (state, payload) => {
    state.brandList = payload.brandList
  },
  [mutationsTypes.STOCK_ADJUST_SET_STOCK_ADJUST_REASON_LIST]: (
    state,
    payload
  ) => {
    state.stockAdjustReasonList = payload.stockAdjustReasonList
  },
  [mutationsTypes.OFTEN_USE_SET_SCREEN_LIST]: (state, payload) => {
    state.oftenUseScreenList = payload.oftenUseScreenList
  },
  [mutationsTypes.COMMON_SET_DISPLAY_API_ALERT]: (state, payload) => {
    state.hasDisplayedApiAlert = payload.hasDisplayed
  },
  [mutationsTypes.FX_SET_FX_RATE_LIST]: (state, payload) => {
    state.fxRateList = payload.fxRateHistory
  },
  [mutationsTypes.LANG_SET_TYPE]: (state, lang) => {
    state.lang = lang
  },
  [mutationsTypes.LEDGER_SHEET_HEADER]: (state, response) => {
    state.ledgerSheetHeader = response.headers
    state.ledgerSheetData = response.data
  },
  [mutationsTypes.SET_IS_LOADING]: (state, response) => {
    response.isLoading ? state.isLoading++ : state.isLoading--
  },
  [mutationsTypes.RESET_IS_LOADING]: (state) => {
    state.isLoading = 0
  }
}

export default Mutations
